import { render, staticRenderFns } from "./approvalPassRouter.vue?vue&type=template&id=a6a0587a"
import script from "./approvalPassRouter.vue?vue&type=script&lang=js"
export * from "./approvalPassRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6a0587a')) {
      api.createRecord('a6a0587a', component.options)
    } else {
      api.reload('a6a0587a', component.options)
    }
    module.hot.accept("./approvalPassRouter.vue?vue&type=template&id=a6a0587a", function () {
      api.rerender('a6a0587a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/router/approvalPassRouter.vue"
export default component.exports